import { FormikProps, getIn } from 'formik';

// Retrieves nested values and check errors and touched status
export function getFormikField<T>(
  formik: FormikProps<T>,
  path: string,
): { error: string; value: any; touched: boolean } {
  let error: any = formik.errors;
  let touched: any = formik.touched;
  let value: any = formik.values;
  const paths = path.split('.');

  for (const key of paths) {
    error = error && error[key];
    touched = touched && touched[key];
    value = value && value[key];
  }

  return {
    error: touched && error ? error : '',
    value: value ?? '',
    touched: !!touched,
  };
}

/** Clears the value if it's currently 0. */
export function onNumberFieldFocus<T>(
  formik: FormikProps<T>,
  fieldPath: string, // may be "details.commissionRate"
) {
  return () => {
    const currentVal = getIn(formik.values, fieldPath);
    if (Number(currentVal) === 0) {
      formik.setFieldValue(fieldPath, '');
    }
  };
}

/** Converts the value to a number on blur; resets to 0 if empty or invalid. */
export function onNumberFieldBlur<T>(
  formik: FormikProps<T>,
  fieldPath: string,
) {
  return () => {
    const currentVal = getIn(formik.values, fieldPath);
    const num = Number(currentVal);
    formik.setFieldValue(fieldPath, isNaN(num) ? 0 : num);
  };
}
